export enum SeoLinkRelEnum {
    FOLLOW = 'follow',
    NOFOLLOW = 'nofollow',
    NOOPENER_NOREFERRER = 'noopener noreferrer',
    NOFOLLOW_NOOPENER_NOREFERRER = 'nofollow noopener noreferrer'
}
